import { defineMessages } from '@approvalmax/utils';

export const messages = defineMessages('pages.RequestFormPage.hooks.useGroupEditItems', {
    itemColumnName: 'Item',
    itemFieldPlaceholder: 'Select item',
    categoryColumnName: 'Category',
    categoryFieldPlaceholder: 'Select category',
    accountColumnName: 'Account',
    accountFieldPlaceholder: 'Select account',
    columnCurrency: 'Currency',
    columnCurrencyPlaceholder: 'Enter currency',
    taxCodeColumnName: 'Tax code',
    taxCodeFieldPlaceholder: 'Select tax code',
    classColumnName: 'Class',
    classFieldPlaceholder: 'Select class',
    departmentColumnName: 'Department',
    departmentFieldPlaceholder: 'Select department',
    locationColumnName: 'Location',
    locationFieldPlaceholder: 'Select location',
    selectDefaultPlaceholder: 'Select value',
    customerColumnName: 'Customer:Project',
    amortizationSchedule: 'Amortization Schedule',
    taxAccountColumnName: 'Tax Account',
    taxAccountFieldPlaceholder: 'Select tax account',
});
